/* istanbul ignore file */
import { LinkButton, LinkButtonProps } from 'framework/ui/ui-builder';
import { useAuthorization } from 'framework/authorization';
import { useFieldHelper } from 'framework/ui/field';
import { useVacancyUrl } from 'domain/recruiting/vacancy/vacancyRoute';

interface CopyVacancyButtonProps extends Omit<LinkButtonProps, 'url'> {
  value?: StringOrNumber;
  permissionToCheck?: string;
}

const CopyVacancyButton = ({ permissionToCheck, ...props }: CopyVacancyButtonProps) => {
  const { getCopyEntityUrl } = useVacancyUrl();
  const { getValue: getId } = useFieldHelper(props);
  const id = getId();
  const { isGranted } = useAuthorization();

  return !permissionToCheck || isGranted(permissionToCheck) ? (
    <LinkButton {...props} url={getCopyEntityUrl(id)}>
      Copy
    </LinkButton>
  ) : null;
};

export default CopyVacancyButton;
